<template>
  <router-view :key="$route.path"/>
</template>

<script>
export default {
  data() {

  },
  mounted() {
   
  }
}
</script>

<style lang="scss">

/*
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;300;400;500;600;700;800;900&display=swap');
*/

@import '@/assets/scss/_fonts.scss';


html {
  height:100vh;
}

body {
  font-family:'Inter', sans-serif;
  background-color:#f9f9f9!important;
  
  .footer {
    position:absolute;
    bottom:0;
    left:0;
    right:0;
    z-index:99;
  }
  position:relative;
  min-height:100vh;

  h2 {
    font-family: "Bebas Neue",sans-serif;
    font-weight: bold;
    line-height: 120%;
    position: relative;
    color: #13294b;
    font-size: 2.8em;
    margin-bottom: 1em;
  }

  .overlay {
    background-color:#000;
    opacity:0.5;
    z-index:9;
    position:fixed;
    width:100%;
    height:100vh;
    top:0;
    left:0;
  }

  .lds-roller {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  .lds-roller div {
    animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    transform-origin: 40px 40px;
  }
  .lds-roller div:after {
    content: " ";
    display: block;
    position: absolute;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #000;
    margin: -4px 0 0 -4px;
  }
  .lds-roller div:nth-child(1) {
    animation-delay: -0.036s;
  }
  .lds-roller div:nth-child(1):after {
    top: 63px;
    left: 63px;
  }
  .lds-roller div:nth-child(2) {
    animation-delay: -0.072s;
  }
  .lds-roller div:nth-child(2):after {
    top: 68px;
    left: 56px;
  }
  .lds-roller div:nth-child(3) {
    animation-delay: -0.108s;
  }
  .lds-roller div:nth-child(3):after {
    top: 71px;
    left: 48px;
  }
  .lds-roller div:nth-child(4) {
    animation-delay: -0.144s;
  }
  .lds-roller div:nth-child(4):after {
    top: 72px;
    left: 40px;
  }
  .lds-roller div:nth-child(5) {
    animation-delay: -0.18s;
  }
  .lds-roller div:nth-child(5):after {
    top: 71px;
    left: 32px;
  }
  .lds-roller div:nth-child(6) {
    animation-delay: -0.216s;
  }
  .lds-roller div:nth-child(6):after {
    top: 68px;
    left: 24px;
  }
  .lds-roller div:nth-child(7) {
    animation-delay: -0.252s;
  }
  .lds-roller div:nth-child(7):after {
    top: 63px;
    left: 17px;
  }
  .lds-roller div:nth-child(8) {
    animation-delay: -0.288s;
  }
  .lds-roller div:nth-child(8):after {
    top: 56px;
    left: 12px;
  }
  @keyframes lds-roller {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .loader {
    background:#FFF;
    top:0;
    left:0;
    bottom:0;
    right:0;
    position:fixed;
    display:flex;
    width:100%;
    height:100vh;
    align-items:center;
    justify-content:center;
    z-index:99;
    opacity:0.9;
  }

  .v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0,0,0,.4) !important;
  z-index: 99 !important;  
  }

  .v-step {
  z-index: 99 !important;
  }

  .mx-context-menu-item:hover {
    background-color: rgba(0,0,0,0.1);
  }

}
</style>
